import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'
import { CaseCTAItem } from 'components/cases/common/CaseCTA'
import { CaseDownloadCTAItem } from 'components/cases/common/CaseDownloadCTA'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: '日本初のMaaSアプリ開発で、地方の高齢化に伴う課題の解決に貢献',
  title1: '日本初のMaaSアプリ開発で、地方の高齢化に伴う課題の解決に貢献',
  introduction_text:
    '地域共生型MaaS「meemo（ミーモ）」アプリのUX/UIデザインとアプリ開発を担当しました。このアプリは、送迎が必要な住民と登録ドライバーをマッチングし、バスやタクシーが利用しにくい地域での移動を支援するものです。弊社はデザインの見直しからクラウドネイティブかつ高速なCI/CD開発手法を用いたアプリ開発まで、一貫して実施しました。',
  company: 'オムロン ソーシアルソリューションズ株式会社',
  tag1text: 'アプリケーション開発',
  tag1src: '/cases/application-development/',
  tag2text: 'クラウドネイティブ',
  tag2src: '/cases/cloudnative/',
  tag3text: 'UX/UI改善',
  tag3src: '/cases/uxui-improvement/',
  industryTagText: 'IT/情報/通信',
  industryTagSrc: '/cases/telecommunications/',
  color: '#fff',
  background: '#078A91',
  staff1: 'コミュニティソリューション事業本部NEXT事業統括本部　横田美希さん',
  staff2: '技術創造センタ技術開発部　久米田晴香さん、平井佐和さん',
  image: '/images/img/cases/meemo/top.webp',
  alt: '日本初のMaaSアプリ開発で、地方の高齢化に伴う課題の解決に貢献',
}

// プロジェクト概要
export const overviewTitle = '日本初のMaaSアプリにおけるUX/UIデザイン～開発をご支援'
export const overviewItem: OverviewItems[] = [
  {
    text: '「MaaS（Mobility as a Service／モビリティ・アズ・ア・サービス）」という言葉をご存知でしょうか？　これはフィンランド・ヘルシンキ市が2014年に公開した、2025年までに地域内の自家用車をゼロにするロードマップをきっかけに生まれた、ICTで多様な移動手段・交通サービスをワンストップで利用可能にする概念です。',
    nonMargin: false,
  },
  {
    text: 'オムロン ソーシアルソリューションズ株式会社（以下、OSS）が提供する「meemo（ミーモ）」は、MaaSを活用し送迎を必要とする住民と、登録ドライバーである住民をマッチングし、バスやタクシーの利用が難しい地域でもスムーズな移動を可能にする点が最大の特徴です。日本の課題である、少子高齢化と都市部への人口集中を解決しようというサービスです。',
    nonMargin: false,
  },
  {
    text: '今回Aitriaでは「meemo」の中核をなすiPhone用アプリ改修版の開発を担当いたしました。',
    nonMargin: true,
  },
  {
    text: 'アプリ開発の知見を活かし、開発に即したデザインへの見直しからクラウドネイティブかつCI/CD(継続開発/継続デリバリ)を高速に提供できる開発手法を用いて実施させていただきました。',
    nonMargin: false,
  },
  {
    text: '「meemo」プロジェクトの中心人物であるOSS　コミュニティソリューション事業本部NEXT事業統括本部の横田美希さん、技術創造センタ技術開発部の久米田晴香さん、平井佐和さんをお迎えして、同プロジェクトの概要と今回のアプリ開発の所感について伺いました。',
    nonMargin: true,
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: '交通サービスの減少による地方の移動手段確保',
        text: '2025年に地方交通事業者のドライバーが大幅に減少する予測に対応し、地方での移動手段を確保する必要がある。',
      },
      {
        title: '高齢者を含むすべての住民の移動ニーズへの対応',
        text: '自由に移動が難しくなる高齢者や地元住民のための使いやすい交通サービスの提供。',
      },
      {
        title: '住民主導のサービスの持続性と拡張性の確保',
        text: '住民自身がサービス提供者となる持続可能なシステムを確立し、広範囲に展開可能な解決策を模索。',
      },
    ],
    solutions: [
      {
        title: 'ユーザーフレンドリーなアプリの開発',
        text: '高齢者を含む全ての住民が容易に使用できるよう、シンプルで直感的なユーザーインターフェースを持つアプリを開発。',
      },
      {
        title: '継続的な改善と技術支援の提供',
        text: 'アプリのユーザビリティを向上させるための継続的な改修と、高速の開発プロセスを通じて迅速な問題解決を実現。',
      },
      {
        title: '実証実験から得たフィードバックの統合',
        text: '初の実証実験を基に集められたユーザーからの具体的なフィードバックを反映させ、さらに使用しやすく、機能的なアプリへと改善。',
      },
    ],
  },
]

// CTA
export const caseCTAItem: CaseCTAItem = {
  title: 'デザインと開発、別々に頼んで疲れていませんか？',
  description:
    '実装を前提としたデザイン設計からAI駆動の開発・リリース後の継続改善まで一気通貫で担い、納期と品質を同時に守ります。まずは、現在の課題やお悩みをお聞かせください。',
}

// 資料ダウンロード CTA
export const caseDownloadCTAItem: CaseDownloadCTAItem = {
  title: 'アプリ開発RFP作成のポイント',
  description: 'アプリ開発担当者向けに、失敗しないためのポイントをテンプレート付の1冊にまとめました',
  imageSrc: '/images/img/cases/cta_rfp.webp',
  href: '/download/rfp/',
}

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
